module.exports = __webpack_public_path__ + "img/live2d-query-detail-icon.838440d4.png";